import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import ErrorBoundary from '@/components/ErrorBoundary'
import '@/index.css'
import { isBenignRuntimeError } from '@/lib/memoryGuard'

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js?v=3').catch(() => {});
  });
}

// Global error safety net — catches ALL uncaught errors and unhandled
// promise rejections so the mobile webview (especially iOS PWAs added to
// the home screen) never crashes and auto-reloads the page.
//
// The ErrorBoundary catches render-time errors, but errors in async
// callbacks (GPS watches, realtime subscriptions, setTimeout, event
// handlers) escape it and become global errors. On mobile, an uncaught
// error can trigger a page reload. A few browser-generated resize loops are
// benign and should be ignored to preserve smooth panning without masking
// real application failures.
window.addEventListener('error', (e) => {
  const msg = e?.message || e?.error?.message || '';
  if (isBenignRuntimeError(msg)) {
    console.warn('[ignored browser resize loop]', msg);
    e.preventDefault();
    e.stopPropagation();
    return true;
  }
  console.error('[uncaught error]', e?.error || e?.message || e);
  e.preventDefault();
  return true;
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e?.reason?.message || (typeof e?.reason === 'string' ? e.reason : '');
  if (isBenignRuntimeError(msg)) {
    console.warn('[ignored browser promise rejection]', msg);
    e.preventDefault();
    return;
  }
  console.error('[unhandled rejection]', e?.reason);
  e.preventDefault();
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
)
